import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// import Moment from 'react-moment';

import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import classNames from 'classnames';

import { Helmet } from 'react-helmet';
// import ReactGA from 'react-ga';

import { Firebase } from '../../../lib/firebase';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

// import ScrollArea from 'react-scrollbar';
// import ScrollAreaButtons from '../UI/ScrollAreaButtons';
import ScrollAreaWrapper from '../UI/ScrollAreaWrapper';

import Leaderboard from './TournamentLeaderboard';
import CustomDate from '../UI/CustomDate';

// import keyImg from '../../../images/icons/private.svg';
import closeImg from '../../../images/icons/close.png';
// import speedImg from '../../../images/icons/fast_game.svg';

// import tutorialImage from '../../../images/icons/game_help.webp';
import tutorialImage from '../../../images/icons/help2.webp';

import {
  getPlayerTournamentsHistory,
  getTournamentPlayers,
  getTournamentsHistory,
} from '../../../actions/tournaments';

import {
  FONT_MODE,
  SCREENS,
} from '../../../constants/constants';
import { getTournamentTitle, getTournamentType } from '../../../utils/tournamentUtils';
import { Input, Label } from 'reactstrap';
import PaginationOld from './PaginationOld';
import { setUserScreenViewNew } from '../../../actions/member';
import TournamentInfo from './TournamentInfo';

class TournamentsHistory extends React.PureComponent {
  static propTypes = {
    tournaments: PropTypes.arrayOf(PropTypes.shape()),
    tournamentPlayers: PropTypes.shape(),
    uid: PropTypes.string,
    // showTournamentTutorial: PropTypes.bool,
    toggleShowTournamentTutorial: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    changeTab: PropTypes.func.isRequired,
    fetchTournamentPlayers: PropTypes.func.isRequired,
    fetchTournamentsHistory: PropTypes.func.isRequired,
    fetchPlayerTournamentsHistory: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    setScreenViewNew: PropTypes.func.isRequired,
  }

  static defaultProps = {
    tournaments: [],
    tournamentPlayers: {},
    uid: null,
    // showTournamentTutorial: false,
    fontMode: FONT_MODE.normal,
  }

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      tournamentId: '',
      scrollPos: 0,
      tournamentInfoModalOpen: false,
      selectTournament: {},
      onlyParticipatedTournaments: false,
      pageSize: 20,
      currentPage: 0,
    };

    this.scrollRef = React.createRef();
  }

  componentDidMount() {
    const { fetchTournamentsHistory, fetchPlayerTournamentsHistory, uid, setScreenViewNew } = this.props;
    setScreenViewNew(SCREENS.TOURNAMENTS.PAST);

    const { hostname } = window.location;

    let devMode = false;

    if (hostname && (hostname.includes('dev') || hostname.includes('localhost'))) {
      devMode = true;
    }

    fetchTournamentsHistory(devMode);
    // fetchPlayerTournamentsHistory(uid);

    Firebase.auth().onAuthStateChanged(async (user) => {
      if (user && user.uid) {
        fetchPlayerTournamentsHistory(user.uid);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.onlyParticipatedTournaments !== this.state.onlyParticipatedTournaments) {
      if (this.scrollRef.current) {
        this.scrollRef.current.scrollArea.scrollTop();
      }
    }
  }

  openModal = (id) => {
    this.setState({
      tournamentId: id,
      openModal: true,
    });
  }

  toggle = () => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
    }));
  }

  fetchTournamentPlayers = (tournamentId) => {
    const { fetchTournamentPlayers, setScreenViewNew } = this.props;

    setScreenViewNew(SCREENS.TOURNAMENTS.RESULTS);

    if (tournamentId) {
      fetchTournamentPlayers(tournamentId).then(() => {
        this.setState({ openModal: true });
      });
    }
  }

  updateScrollPos = (val) => {
    if (val.topPosition || val.topPosition === 0) {
      this.setState({ scrollPos: val.topPosition || 0 });
    }
  //  this.setState({ scrollPos: val.topPosition || 0 });
  }

  scroll = (newVal) => {
    this.tableScrollbar.scrollYTo(newVal);
  }

  openTournamentInfoModal = (selectId) => {
    const { tournaments, setScreenViewNew } = this.props;
    setScreenViewNew(SCREENS.TOURNAMENTS.INFO);

    this.setState({
      tournamentInfoModalOpen: true,
      selectTournament: {
        ...tournaments.filter(tournament => tournament.id === selectId)[0],
      },
    });
  }

  closeTournamentInfoModal = () => {
    this.setState({
      tournamentInfoModalOpen: false,
    });
  }

  toggleOnlyParticipatedTournaments = () => {
    this.setState(prevState => ({
      onlyParticipatedTournaments: !prevState.onlyParticipatedTournaments,
      currentPage: 0,
    }));
  }

  handlePagination = (e, index) => {
    e.preventDefault();
    this.setState({
      currentPage: index,
    });
  }

  render() {
    const {
      t,
      tournaments,
      playerTournaments,
      uid,
      changeTab,
      tournamentPlayers,
      toggleShowTournamentTutorial,
      fontMode,
    } = this.props;

    const {
      openModal,
      tournamentId,
      // scrollPos,
      selectTournament,
      tournamentInfoModalOpen,
      onlyParticipatedTournaments,
      pageSize,
      currentPage,
    } = this.state;

    const playerTournamentsKeys = (playerTournaments && playerTournaments.length) ? playerTournaments.map(tournament => tournament.key) : [];
    const tournamentsShown = (onlyParticipatedTournaments ? tournaments.filter((tournament) => playerTournamentsKeys.includes(tournament.key)) : tournaments)
       .filter((tournament) => tournament.currentState !== 'play' && tournament.currentState !== 'pause');

    let pagesCount = Math.ceil(tournamentsShown.length / pageSize);

    return (
      <>
        <Helmet>
          <title>
            {`Zole - ${t('route.tournaments')}`}
          </title>
        </Helmet>

        {/*  <ScrollAreaButtons
          scrollPos={scrollPos}
        //  show={this.tableScrollbar && this.tableScrollbar.state && this.tableScrollbar.state.containerHeight < this.tableScrollbar.state.realHeight ? true : null}
          show={tournaments && tournaments.length > 7 ? true : null}
          scroll={this.scroll}
          speed={30}
          rightOffset={17}
          topOffset={50}
          bottomOffset={38}
        />
        <ScrollArea
          speed={0.55}
          className="tournaments-scrollarea"
          contentClassName="tournaments-scrollarea-body"
          smoothScrolling
          stopScrollPropagation
          verticalContainerStyle={{
            background: 'transparent',
            opacity: 1,
            width: 11,
          }}
          verticalScrollbarStyle={{
            background: '#fff',
            borderRadius: 1,
            width: 10,
            minHeight: 10,
            minScrollSize: 25,
          }}
          horizontal={false}
          onScroll={this.updateScrollPos}
          ref={(el) => {
            this.tableScrollbar = el;
          }}
        > */}
        <div className="tournaments-filter">
          <Label check
              style={{marginTop: 2, marginLeft: 20, alignItems: 'center'}}
              className="d-flex"
          >

              <Input
                  type="checkbox"
                  id="onlyParticipatedTournaments"
                  name="onlyParticipatedTournaments"
                  onChange={this.toggleOnlyParticipatedTournaments}
                  checked={onlyParticipatedTournaments}
                  className="mt-0"
              />
              <div>{t('tournaments.showParticipatedTournaments')}</div>
          </Label>
        </div>
        {(tournamentsShown.length === 0 && onlyParticipatedTournaments) ? (
          <div className="tournaments-empty-entries-old">
            {t('tournaments.noParticipatedTournaments')}
          </div>
        ) : (
          <>
            <ScrollAreaWrapper
              className={`tournaments-scrollarea tournaments-scrollarea-font-based-margin-${fontMode} mb-2`}
              contentClassName="tournaments-scrollarea-body tournaments-scrollarea-body-past"
              show={tournaments && tournaments.length > 7 ? true : null}
              rightOffset={17}
              topOffset={39}
              bottomOffset={67}
              scrollRef={this.scrollRef}
            >

              {tournaments && tournaments.length && (tournamentsShown.slice(currentPage * pageSize, (currentPage + 1) * pageSize).map((tournament, idx) => {
                const { startDate, registerTime } = tournament;
                let registerDate;
                if (startDate && registerTime) {
                  registerDate = startDate - (registerTime * 1000 * 60);
                }
                // console.log(idx, "number");

                return (
                  <Fragment key={tournament.id}>
                    <div className={classNames('active-tournaments', {
                      'active-tournaments-first': idx === 0,
                    })}
                    >
                      <div className="active-tournaments-info">
                        <div className="active-tournaments-info-section">
                          <div className="active-tournaments-info-section-title">
                            <div className="active-tournaments-info-section-title-left">
                              <Media src={tutorialImage} onClick={() => this.openTournamentInfoModal(tournament.id)} className="active-tournaments-info-section-title-left-img" alt="x"/>
                              <span className="active-tournaments-info-section-title-left-title">{getTournamentTitle(tournament)}</span>
                              <span className="active-tournaments-info-section-title-left-private first-capitial">
                                { getTournamentType(tournament, t) }
                              </span>
                            </div>
                            <div className='d-flex flex-row gap-5'>
                              {tournament?.restrictions && (
                                <div className={classNames('active-tournaments-info-section-title-right history-tournaments-info-section-title-right')}>
                                  <div>{t(`common.restrictions`)}</div>
                                </div>
                              )}
                              <div className="active-tournaments-info-section-title-right history-tournaments-info-section-title-right">
                                <div>{`${t('tournaments.closed')} `}</div>
                              </div>
                            </div>
                          </div>
                          <div className="active-tournaments-info-section-time">
                            <span className="active-tournaments-info-section-time-rounds">{`${t('tournaments.rounds')}:`}</span>
                            <span className="active-tournaments-info-section-time-roundsValue">{tournament.rounds}</span>
                            <span className="active-tournaments-info-section-time-label">{`${t('tournaments.beginning')}:`}</span>
                            <span className="active-tournaments-info-section-time-content"><CustomDate format="DD.MM.YYYY hh:mm" date={startDate} /></span>
                          </div>
                        </div>
                        <div className="active-tournaments-info-button">
                          <Button color="link" className="btn notification-footer-button" onClick={() => this.fetchTournamentPlayers(tournament.key)}>{t('tournaments.result')}</Button>
                        </div>
                      </div>
                      <div className={
                        classNames('active-tournaments-sponsor', {
                          'active-tournaments-sponsor-two': tournament?.sponsorImg && tournament?.prizeImg
                        })}
                      >
                        {
                          tournament?.sponsorImg && (
                            <div className={
                              classNames('active-tournaments-sponsor-section', {
                                'active-tournaments-sponsor-section-two': tournament?.sponsorImg && tournament?.prizeImg
                              })}
                            >
                              <span>{t('tournaments.sponsorTournaments')}</span>
                              <Media src={tournament?.sponsorImg} alt="x" />
                            </div>
                          )
                        }
                        {
                          tournament?.prizeImg && (
                            <div className={
                              classNames('active-tournaments-sponsor-section', {
                                'active-tournaments-sponsor-section-two': tournament?.sponsorImg && tournament?.prizeImg
                              })}
                            >
                              <span>{t('tournaments.mainPrize')}</span>
                              <Media src={tournament?.prizeImg} alt="x" />
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </Fragment>
                );
              }))}
            </ScrollAreaWrapper>

            <PaginationOld
              show={tournamentsShown.length > pageSize}
              currentPage={currentPage}
              pagesCount={pagesCount}
              handlePagination={this.handlePagination}
            />
          </>
        )}


        <TournamentInfo
          tournamentInfoModalOpen={tournamentInfoModalOpen}
          closeTournamentInfoModal={this.closeTournamentInfoModal}
          selectTournament={selectTournament}
          fontMode={fontMode}
        />

        {uid && tournamentPlayers && openModal ? (
          <Modal container={'div > div'} returnFocusAfterClose={false} size="lg" isOpen={openModal} toggle={this.toggle} className={`old-modal root-font-${fontMode}`}>
            <ModalHeader
              toggle={this.toggle}
              close={
                <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.toggle} />
              }
            >
              {t('tournaments.complete')/*t('tournaments.top')*/}
            </ModalHeader>
            <ModalBody>
              <Leaderboard tournament={selectTournament} leaderboard={tournamentPlayers} tournamentId={tournamentId} uid={uid} />
            </ModalBody>
            <ModalFooter>
              <Button color="link" className="modal-footer-button" onClick={this.toggle}>{t('tournaments.close')}</Button>
            </ModalFooter>
          </Modal>
        ) : (null)}
      </>
    );
  }
}

const mapStateToProps = state => ({
  ignoredUsers: state.member.ignoredUsers || {},
  uid: state.member.uid || null,
  playerTournaments: (state.tournaments && state.tournaments.playerTournamentsHistory) ? state.tournaments.playerTournamentsHistory : [],
  tournaments: (state.tournaments && state.tournaments.tournamentsHistory) ? state.tournaments.tournamentsHistory : [],
  tournamentPlayers: (state.tournaments && state.tournaments.tournamentPlayers) ? state.tournaments.tournamentPlayers : {},
});

const mapDispatchToProps = {
  fetchTournamentPlayers: getTournamentPlayers,
  fetchTournamentsHistory: getTournamentsHistory,
  fetchPlayerTournamentsHistory: getPlayerTournamentsHistory,
  setScreenViewNew: setUserScreenViewNew,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(TournamentsHistory));
